import { SaleBannerWithLoader } from './loaders';

export const SalesCollections = () => <SaleBannerWithLoader />;
